import { render, staticRenderFns } from "./CourseFormDialog.vue?vue&type=template&id=38f4bcd8&scoped=true"
import script from "./CourseFormDialog.vue?vue&type=script&lang=js"
export * from "./CourseFormDialog.vue?vue&type=script&lang=js"
import style0 from "./CourseFormDialog.vue?vue&type=style&index=0&id=38f4bcd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f4bcd8",
  null
  
)

export default component.exports